import React from 'react';
import Type from 'prop-types';
import { Button } from '@mui/material';
import { TextField } from 'formik-mui';

import { Field, Form } from 'formik';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { UserSearch } from 'components';
import { fullDateShortTimeFormat } from 'constants/dateFormats';
import { MAX_LENGTH_MESSAGE, taskPriorities, taskTypes } from 'constants/tasks';
import { useTranslation } from 'hooks';
import styles from './EditForm.module.css';

const EditForm = (props) => {
  const { username, userFullName, formikBag, onCancel } = props;
  const { t } = useTranslation();

  const isAssignToMe = () => {
    const { assignees } = formikBag.values;
    const isAssignToMeValue = assignees.filter((item) => item.id === username);
    return isAssignToMeValue.length !== 0;
  };

  const handleAssignToMe = () => {
    const { assignees } = formikBag.values;

    const user = { id: username, userFullName };

    formikBag.setFieldValue('assignees', [...assignees, user]);
  };

  return (
    <Form noValidate>
      <Field
        component={TextField}
        name="content"
        label={t('taskName')}
        margin="normal"
        inputProps={{
          maxLength: MAX_LENGTH_MESSAGE,
        }}
        helperText={t('maxLengthMessage')}
        maxRows={4}
        multiline
        fullWidth
        required
        variant="standard"
        value={formikBag.values.content}
        onChange={formikBag.handleChange}
      />

      <Field
        name="type"
        as={TextField}
        label={t('taskType')}
        SelectProps={{
          native: true,
        }}
        margin="normal"
        fullWidth
        select
        required
        variant="standard"
        value={formikBag.values.type}
        onChange={formikBag.handleChange}
      >
        {Object.values(taskTypes).map((type) => (
          <option key={type.value} value={type.value}>
            {type.label}
          </option>
        ))}
      </Field>

      <UserSearch textFieldProps={{ required: true }} />

      {!isAssignToMe() && (
        <Button
          size="small"
          color="primary"
          classes={{ text: styles.assignButton }}
          onClick={handleAssignToMe}
        >
          {t('assignToMe')}
        </Button>
      )}

      <Field name="due">
        {({ field, form }) => (
          <DateTimePicker
            label={t('due')}
            value={field.value}
            format={fullDateShortTimeFormat}
            ampm={false}
            disablePast
            onChange={(value) => form.setFieldValue(field.name, value)}
            slotProps={{
              textField: {
                margin: 'normal',
                fullWidth: true,
                required: true,
                variant: 'standard',
              },
            }}
          />
        )}
      </Field>

      <Field
        name="priority"
        as={TextField}
        label={t('priority')}
        SelectProps={{
          native: true,
        }}
        margin="normal"
        select
        fullWidth
        required
        variant="standard"
        value={formikBag.values.priority}
        onChange={formikBag.handleChange}
      >
        {Object.values(taskPriorities).map((taskPriority) => (
          <option key={taskPriority.id} value={taskPriority.id}>
            {taskPriority.label}
          </option>
        ))}
      </Field>

      <div className={styles.buttonsWrapper}>
        <Button color="primary" onClick={onCancel}>
          {t('cancel')}
        </Button>
        <Button type="submit" color="primary" disabled={formikBag.isSubmitting}>
          {t('save')}
        </Button>
      </div>
    </Form>
  );
};

EditForm.propTypes = {
  formikBag: Type.any.isRequired, // eslint-disable-line react/forbid-prop-types,
  onCancel: Type.func.isRequired,
  username: Type.string.isRequired,
  userFullName: Type.string.isRequired,
};

export default EditForm;
